import { Loader2, Shield } from "lucide-react";

export function Loading() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex flex-col items-center space-y-4">
        <div className="relative">
          <Shield className="h-12 w-12 text-[oklch(0.45_0.15_142)]" />
          <Loader2 className="absolute inset-0 h-12 w-12 animate-spin text-[oklch(0.40_0.15_142)]" />
        </div>
        <div className="space-y-2 text-center">
          <h2 className="text-lg font-semibold text-[oklch(0.35_0.15_142)]">
            Carregando Sistema
          </h2>
          <p className="text-sm text-muted-foreground">
            Aguarde enquanto preparamos os dados...
          </p>
        </div>
        <div className="flex space-x-1">
          <div className="h-2 w-2 bg-[oklch(0.45_0.15_142)] rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="h-2 w-2 bg-[oklch(0.45_0.15_142)] rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="h-2 w-2 bg-[oklch(0.45_0.15_142)] rounded-full animate-bounce"></div>
        </div>
      </div>
    </div>
  );
}
